var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.remove}},[_c('b-icon',{attrs:{"icon":"person-dash-fill"}}),_vm._v(" 削除 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }